import {
  ADD_CHART3_VALUES,
  ADD_CHART4_VALUES,
  ADD_CHART5_VALUES,
  ADD_CHART6_VALUES,
} from "./actions.type";
import {
  SET_CHART3_VALUES,
  SET_CHART4_VALUES,
  SET_CHART5_VALUES,
  SET_CHART6_VALUES,
} from "./mutations.type";

export default {
  [ADD_CHART3_VALUES]({ commit }, payload) {
    return new Promise((resolve) => {
      commit(SET_CHART3_VALUES, payload);
      resolve(payload);
    });
  },
  [ADD_CHART4_VALUES]({ commit }, payload) {
    return new Promise((resolve) => {
      commit(SET_CHART4_VALUES, payload);
      resolve(payload);
    });
  },
  [ADD_CHART5_VALUES]({ commit }, payload) {
    return new Promise((resolve) => {
      commit(SET_CHART5_VALUES, payload);
      resolve(payload);
    });
  },
  [ADD_CHART6_VALUES]({ commit }, payload) {
    return new Promise((resolve) => {
      commit(SET_CHART6_VALUES, payload);
      resolve(payload);
    });
  },
};
